"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reporter = exports.errorReporter = exports.default = exports.createErrorReporter = exports.createCrashReporter = exports.createAnalyticsReporter = exports.crashReporter = void 0;

var defaultSelect = function defaultSelect(_ref) {
  var _ref$meta = _ref.meta,
      meta = _ref$meta === void 0 ? {} : _ref$meta;
  return meta.analytics;
};

var reporter = function reporter(handler) {
  var select = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSelect;
  return function (_ref2) {
    var getState = _ref2.getState;
    return function (next) {
      return function (action) {
        var returnValue = next(action);

        if (typeof action === 'function') {
          return returnValue;
        }

        var report = select(action);

        if (!report) {
          return returnValue;
        }

        handler(report, getState);
        return returnValue;
      };
    };
  };
};

exports.reporter = reporter;

var errorSelect = function errorSelect(_ref3) {
  var _ref3$error = _ref3.error,
      error = _ref3$error === void 0 ? false : _ref3$error,
      payload = _ref3.payload,
      type = _ref3.type;

  if (!error) {
    return null;
  }

  if (!payload) {
    console.warn('Actions that represent errors should have an error object as payload, generic error used');
    return new Error(type);
  }

  return payload;
};

var errorReporter = function errorReporter(handler) {
  return reporter(handler, errorSelect);
};

exports.errorReporter = errorReporter;

var crashReporter = function crashReporter(handler) {
  return function (_ref4) {
    var getState = _ref4.getState;
    return function (next) {
      return function (action) {
        var returnValue;

        try {
          returnValue = next(action);
        } catch (err) {
          handler(err, getState);
          console.error(err);
        }

        return returnValue;
      };
    };
  };
};

exports.crashReporter = crashReporter;

var errorReport = function errorReport(tracker) {
  return function (error) {
    try {
      tracker.trackError(error);
    } catch (err) {}
  };
};

var createAnalyticsReporter = function createAnalyticsReporter(tracker) {
  return reporter(function (_ref5) {
    var type = _ref5.type,
        payload = _ref5.payload;

    try {
      tracker.track(type, payload);
    } catch (err) {}
  });
};

exports.createAnalyticsReporter = createAnalyticsReporter;

var createCrashReporter = function createCrashReporter(tracker) {
  return crashReporter(errorReport(tracker));
};

exports.createCrashReporter = createCrashReporter;

var createErrorReporter = function createErrorReporter(tracker) {
  return errorReporter(errorReport(tracker));
};
/**
 * Takes in a tracker object, builds an array of reporters to be used in redux
 * @param {Tracker} tracker - the tracker object created via tracker analytics
 * @returns {Array} array of reporters to be used for redux middleware.
 */


exports.createErrorReporter = createErrorReporter;

var createAnalyticsMiddleware = function createAnalyticsMiddleware(tracker) {
  if (!tracker) {
    throw Error('Cannot create analytics middleware, no tracker provided');
  }

  return [createCrashReporter(tracker), createAnalyticsReporter(tracker), createErrorReporter(tracker)];
};

var _default = createAnalyticsMiddleware;
exports.default = _default;